import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import StandardTabs from '@ifca-root/react-component/src/components/Tabs/StandardTabs'
import theme from '@ifca-root/react-component/src/assets/theme'
import { useMediaQuery } from '@material-ui/core'
import { useGetCreditorAccountQuery } from 'generated/graphql'
import React, { useMemo, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { PayeeDetailsListing } from './PayeeDetailsListing'

export const PayeeDetailsTab = (props: any) => {
  let history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { BankEFTID }: any = useParams()
  const [value, setValue] = useState(0)
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const {
    data: { getCreditorAccount } = { getCreditorAccount: [] },
  } = useGetCreditorAccountQuery({
    fetchPolicy: 'network-only',
  })

  const activeCount = useMemo(
    () =>
      getCreditorAccount?.filter(el => el?.CreditorStatus === 'ACTIVE')
        ?.length ?? 0,
    [getCreditorAccount]
  )

  const inactiveCount = useMemo(
    () =>
      getCreditorAccount?.filter(el => el?.CreditorStatus === 'INACTIVE')
        ?.length ?? 0,
    [getCreditorAccount]
  )

  return (
    <>
      <MainHeader
        mainBtn="back"
        onClick={() => history.push(`/bank-eft/${BankEFTID}`)}
        smTitle={'AccountX'}
        title={user?.accountName}
        routeSegments={[
          { name: 'EFT Settings' },
          { name: 'Payee Profile', current: true },
        ]}
      />

      <StandardTabs
        value={value}
        onChange={handleChange}
        responsive
        fullWidth
        subHeader
        style={{
          boxShadow: 'none',
          ...(isDesktop ? { marginTop: '55px' } : { marginTop: '0px' }),
        }}
        tabs={[
          {
            label: `Available (${activeCount})`,
            content: <PayeeDetailsListing pageMode="active" />,
          },
          {
            label: `Registered (${inactiveCount})`,
            content: <PayeeDetailsListing pageMode="inactive" />,
          },
        ]}
      />
    </>
  )
}
